import {Props} from './model';
import React from 'react';
import {View} from 'react-native';
import {useStyles} from '../../../../shared/hooks/styles';
import {Markdown} from '../../../../shared/components/markdown';

export default ({content}: Props) => {
  const styles = useStyles(() => ({
    container: {
      flexDirection: 'row',
    },
    markdownRoot: {
      maxWidth: '100%',
    },
  }));

  return (
    <View style={styles.container}>
      <Markdown style={styles.markdownRoot} listColumns={2}>
        {content.services.transportService.nonFinancial.eCardFeaturesHtml}
      </Markdown>
    </View>
  );
};
